
<div 
  id="el-related-articles"
  class=" mt-10 w-[1444px] mx-auto font-normal font-rubik text-[#334155] border-y border-[#D4CBBF] p-28 bg-white flex flex-col gap-20"
>
  <div class="flex justify-between items-end">
    <div class="flex flex-col gap-4">
      <h3 class="text-[2.5rem] leading-[3rem]">Related Articles</h3>
      <span class="text-[1.125rem] leading-[1.6875rem]">Here are articles related to the subject of this page</span>
    </div>
    <a :href="allArticlesPath" class="text-[1rem] leading-[1.5rem] px-6 py-2 hover:underline">View all</a>
  </div>
  <div class="flex flex-wrap gap-8">
    <ArticleCard v-for="(article, index) in articles" :key="index" :article="article" />
  </div>
</div>
